// extracted by mini-css-extract-plugin
export default {"container":"styles_container__9pe9N","image":"styles_image__gN2QQ","cards":"styles_cards__u7EjG","card":"styles_card__GcLD0"};